const emptyAuthState = {
  isFetchingUser: false,
  user: {},
  employee: {},
  allEmployees: [],
  logs: []
}

export default emptyAuthState
